module.exports = function() {
  return new Worker(__webpack_public_path__ + "1cd723351987072c636c.worker.js");
};